import { mdiViewAgenda, mdiViewGrid, mdiViewList } from "@mdi/js";
import Icon from "@mdi/react";
import React from "react";
import {
  ButtonGroup,

  IconButton
} from "rsuite";
import { useLocation } from "./../hooks/useLocation";
import { doHref } from "./../utils/doHref";

export const ToolbarViewSwitcher = () => {
  const { params } = useLocation();

  const { view } = params;

  return (
    <ButtonGroup>
      <IconButton
        href={doHref({ ...params, view: null })}
        appearance={!view || view === "grid" ? "primary" : "default"}
        icon={<Icon path={mdiViewGrid} />}
      />
      <IconButton
        href={doHref({ ...params, view: "list" })}
        appearance={view === "list" ? "primary" : "default"}
        icon={<Icon path={mdiViewList} />}
      />
      <IconButton
        appearance={view === "detail" ? "primary" : "default"}
        href={doHref({ ...params, view: "detail" })}
        icon={<Icon path={mdiViewAgenda} />}
      />
    </ButtonGroup>
  );
};
